<template>
  <div class="box">
    <div class="box-header">
      Order History
    </div>
    <div class="content">
      <!-- Empty state -->
      <div v-if="logs.length === 0" class="empty-state">
        <i class="mdi mdi-history"></i>
        <p>No history yet</p>
      </div>
      <!-- Logs table -->
      <div v-else class="table-scroll">
        <table class="default-table logs-table">
          <thead>
            <tr>
              <th>Message</th>
              <th style="width: 170px">Date</th>
              <th style="width: 120px">Status</th>
              <th style="width: 180px">Admin name</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in logs" :key="log.id">
              <td class="log-message">
                {{ log.message }}
              </td>
              <td class="log-date">
                {{ log.date | dateWithHours }}
              </td>
              <td class="log-status-cell">
                <span v-if="log.status" class="log-status">
                  {{ log.status }}
                </span>
              </td>
              <td class="log-admin">
                {{ log.adminName }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderLogs",
  props: {
    logs: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;

  i {
    font-size: 2.25rem;
    color: #d1d5db;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
}

.table-scroll {
  overflow-x: auto;
}

.log-message {
  white-space: pre-line;
}

.log-date {
  white-space: nowrap;
  color: #6b7280;
}

/* Movil: lista en vez de tabla. Con 470px de columnas fijas (y table-layout
   fixed del modal de orden) el mensaje quedaba en 0px, letra por letra.
   !important: le gana a las reglas de tabla del modal de orden */
@media (max-width: 767px) {
  .table-scroll {
    overflow-x: visible;
  }

  .logs-table,
  .logs-table tbody {
    display: block;
  }

  .logs-table thead {
    display: none;
  }

  .logs-table tr {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 10px;
    padding: 10px 12px;
    border-bottom: 1px solid #f3f4f6;
  }

  .logs-table td {
    display: block;
    width: auto !important;
    padding: 0 !important;
    border: none !important;
  }

  .logs-table td:empty {
    display: none;
  }

  .logs-table .log-message {
    flex: 1 0 100%;
    color: #111827;
  }

  .logs-table .log-date,
  .logs-table .log-admin {
    font-size: 14px;
    color: #6b7280;
  }

  .logs-table .log-status {
    font-size: 13px;
  }
}

.log-status {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  background: #f3f4f6;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}
</style>
